import { Injectable } from '@angular/core';

import { Exception, ScheduleHours } from '@shared/schedule/models';
import { getIntervals, inIntervals } from '@shared/schedule/functions';

@Injectable({providedIn: 'root'})
export class ScheduleService {
  /**
   * How it works:
   * 1. Generates intervals for the given, the previous and the next days. Previous day contains
   *    negative values for correct calculations.
   * 2. Merges these intervals, see description of mergeIntervals()
   * 3. Check if the given date and time inside any interval (respect service duration or
   *    not).
   *
   * @param hours
   * @param exceptions
   * @param {number} timestamp UTC time
   * @param {string} timezone Restaurant's timezone
   * @param {number} duration Respect service duration or not
   * @returns {boolean} is given date and time in schedule
   */
  check(hours: ScheduleHours, exceptions: Exception[], timestamp: number, timezone: string, duration = 0): boolean {
    return inIntervals(
      getIntervals(hours, exceptions, timestamp, timezone),
      timestamp,
      timestamp + duration,
    );
  }
}
